import styled from "styled-components";
import * as M from "@discovery/prelude/lib/data/maybe";
import { useMemo, useState } from "@discovery/common-dplus/lib/hooks";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { SonicImage } from "../../atoms/sonic-image";
import { Icon, Icons } from "../../../components/atoms/icon";
import { createPlayer } from "../../../utils/dplus/createPlayer";
import { VideoWrapper } from "../../../component-creators/player";
import styles from "../../../component-creators/player/styles.css";
export const PLAY_BUTTON_SIZE = 60;
const ImageContainer = styled.div `
  position: relative;
  .play-button {
    position: absolute;
    left: calc(50% - ${PLAY_BUTTON_SIZE}px / 2);
    top: calc(50% - ${PLAY_BUTTON_SIZE}px / 2);
    cursor: pointer;
    transition:
      transform 0.2s ease-out,
      opacity 0.2s ease-in-out;
    width: 4vw;
    height: 4vw;
    min-width: 40px;
    min-height: 40px;
    opacity: 0.7;
    &:hover {
      opacity: 1;
    }
  }
`;
const adConfig = {
    enableAds: false,
    shortsVastTag: "",
    vastTag: "",
};
export const Carousel = ({ streamIdM, environment, imageDataM, }) => {
    const [videoVisible, setVideoVisible] = useState(false);
    const Player = useMemo(() => createPlayer(environment, adConfig, false, undefined, {
        autoplay: false,
    }), [environment]);
    return (React.createElement(React.Fragment, null, videoVisible ? (React.createElement(RenderMaybe, null, M.map((streamId) => (React.createElement("div", { className: styles.videoElementWrapper },
        React.createElement("div", { className: styles.videoElement },
            React.createElement(VideoWrapper, null,
                React.createElement(Player, { streamId: streamId, callbacks: {
                        onEnded: () => setVideoVisible(false),
                    } }))))), streamIdM))) : (React.createElement(RenderMaybe, null, M.map((x) => (React.createElement(ImageContainer, { onClick: () => setVideoVisible(true) },
        React.createElement(SonicImage, { image: x.attributes, className: "cover-image", imageSizes: {
                default: [78, "vw"],
                maxWidthMediaQueries: [[1439, "px", 90, "vw"]],
            }, style: { borderRadius: 6 }, fallbackImageSize: { width: 1439 }, alt: "cover" }),
        React.createElement(Icon, { type: Icons.RoundedPlayIcon, className: "play-button" }))), imageDataM)))));
};

